import { GenericTableHead } from 'dashboard409a/components/ValuationsTable/common';
import { ModelsTableHeadProps } from '../ModelsTable.types';

const ModelsTableHead = ({
  order,
  orderBy,
  sortCriteria,
  onRequestSort,
  columns,
  columnWidths,
  onColumnWidthChange,
}: ModelsTableHeadProps) => (
  <GenericTableHead
    order={order}
    orderBy={orderBy}
    sortCriteria={sortCriteria}
    onRequestSort={onRequestSort}
    columns={columns}
    columnWidths={columnWidths}
    onColumnWidthChange={onColumnWidthChange}
  />
);

export default ModelsTableHead;
